module.exports = __webpack_public_path__ + "static/media/Iceland.f77874f4.png";